import React from 'react';
import { withRouter } from 'react-router-dom';
import './styles.css';
function Content(props) {
	return <main className="main-content">{props.children}</main>;
}

export default withRouter(Content);
